import {API} from 'aws-amplify';

export default instanceId => {
  return API.get('WBU', '/commandsequence', {queryStringParameters: {instanceId}});
};


// WEBPACK FOOTER //
// ./src/components/content/instanceScreenshotViewer/util/getSequenceData.js